export default __webpack_public_path__ + "static/media/Inspection_Black.925595ff.webp";